import Title from "components/shared/Title";
import RelatedQuestionWall from "components/questions/RelatedQuestionWall";
import { Fragment } from "react";
import { HEADING_TYPES } from "components/shared/Heading";

const Description = ({ description, name, relatedQuestions }) => {
	const mainClass = "help-description";
	const titleModifier = "description";
	return (
		<Fragment>
			<div className={mainClass}>
				{name && (
					<Title
						title={name}
						modifier={titleModifier}
						headingType={HEADING_TYPES.h2}
					/>
				)}
				{description && (
					<div
						className={`${mainClass}__content`}
						dangerouslySetInnerHTML={{ __html: description }}
					></div>
				)}
			</div>
			{relatedQuestions && (
				<RelatedQuestionWall relatedQuestions={relatedQuestions} />
			)}
		</Fragment>
	);
};
export default Description;
